import { getCashOutOverview } from "@payping/redux/actions";
import { FC } from "react";
import { useAsync } from "react-use";
import { useAppDispatch } from "@/utils";
import List from "./List";

const Id: FC = () => {
  const dispatch = useAppDispatch();

  useAsync(() => dispatch(getCashOutOverview()));

  return <List />;
};

export default Id;
